import { createSlice } from "@reduxjs/toolkit";

/**
 * TODO just save the round ID -- to avoid caching issues with round data.
 * 
 * Save selectedRound to localStorage, so that it persists across page reloads
 * Load selectedRound from localStorage (if available)
 */
const loadSelectedRound = () => {
  try {
    const storedData = localStorage.getItem("selectedRound");
    return storedData ? JSON.parse(storedData) : null;
  } catch (error) {
    console.error("Error loading selectedRound from localStorage:", error);
    return null;
  }
};

export const issbRoundSlice = createSlice({
  name: "issbRound",
  initialState: {
	currentRoundId: loadSelectedRound()?.id, // TODO switch to this (less caching issues)
	/**TODO just use the round ID -- to avoid caching issues with round data. */
    selectedRound: loadSelectedRound(),
    roundList: [],
	/** TODO doc: Which questions are these?? Why store them here?? 
	 * @deprecated They're used in AuthUtils.js -- but this has caching issues. Can we replace this DIY cache with useQuery() for clearer cache management? */
    questions: [],	
	/** TODO similar to questions, can this be replaced with local use of useQuery()? */
    audits: [],
  },
  reducers: {
    setSelectedRound: (state, action) => {
      state.selectedRound = action.payload;
      state.currentRoundId = action.payload?.id;
	  // Persist data to localStorage
      localStorage.setItem("selectedRound", JSON.stringify(action.payload));
	  localStorage.setItem("currentRoundId", action.payload?.id); 
    },
    setRoundList: (state, action) => {
      state.roundList = action.payload;
    },
    setQuestions: (state, action) => {
      state.questions = action.payload;
    },
    setAudits: (state, action) => {
      state.audits = action.payload;
    },
  },
});

export const { setSelectedRound, setRoundList, setQuestions, setAudits } = issbRoundSlice.actions;

export default issbRoundSlice.reducer;
